export default __webpack_public_path__ + "static/media/product.03a9e3d2.png";